import { render, staticRenderFns } from "./memberCenter.vue?vue&type=template&id=66fc89f8&scoped=true&"
import script from "./memberCenter.vue?vue&type=script&lang=js&"
export * from "./memberCenter.vue?vue&type=script&lang=js&"
import style0 from "./memberCenter.vue?vue&type=style&index=0&id=66fc89f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fc89f8",
  null
  
)

export default component.exports